import React, { useState } from 'react';
import { GridColumn } from '@progress/kendo-react-grid';
import FormRow from '../formRow';
import GridInline from '../grid';
import PopUpConfirm from '../popUps/popUpConfirm';
import './styles.css';
import GoogleAgendaLink from '../utils/googleAgendaLink';

const Schedule = ({
  schedules,
  setSchedules,
  deleteColumn,
  onItemDelete,
  editColumn,
  onItemEdit,
  email
}) => {
  const [loading, setLoading] = useState(false);
  const [popUpConfirmDelete, setPopUpConfirmDelete] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);

  const confirmDelete = (schedule) => {
    if (selectedSchedule) onItemDelete(selectedSchedule);
  };

  const canDelete = (schedule) => {
    setSelectedSchedule(schedule);
    return true;
  };

  const parseTextWithLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const finalText = text.split(urlRegex).map((part, index) =>
      urlRegex.test(part) ? (
        <a
          className="link-inline"
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
        >
          {part}
        </a>
      ) : (
        part
      )
    );
    return <td className="td-word-break">{finalText}</td>;
  };

  const HyperlinkCell = (props) => {
    const { dataItem, field } = props;
    const text = dataItem[field];

    return <td>{parseTextWithLinks(text)}</td>;
  };

  return (
    <div>
      <>
        <FormRow withShrink>
          <GridInline
            data={schedules}
            setData={setSchedules}
            deleteColumn={deleteColumn}
            editColumn={editColumn}
            onItemEdit={onItemEdit}
            canDelete={canDelete}
            onItemDelete={onItemDelete}
            confirmDelete={true}
          >
            <GridColumn
              field="DataCriacao"
              title="Data de Criação"
              editable={false}
              format="{0:dd/MM/yyyy HH:mm}"
              width={170}
            />
            <GridColumn
              field="DataModificacao"
              title="Data de Modificação"
              editable={false}
              format="{0:dd/MM/yyyy HH:mm}"
              width={170}
            />
            <GridColumn
              field="Descricao"
              title="Título"
              editable={false}
              width="350px"
              cell={HyperlinkCell}
            />
            <GridColumn field="UsuarioNome" title="Usuário" editable={false} />
            <GridColumn field="ResponsavelNome" title="Agendado para" editable={false} />
            <GridColumn
              field="Data"
              title="Data de Agendamento"
              editable={false}
              format="{0:dd/MM/yyyy HH:mm}"
              width={170}
            />
            <GridColumn
              editable={false}
              width={50}
              cell={(props) => {
                const date1 = props.dataItem.Data;
                const date2 = new Date(date1.getTime() + 60 * 60 * 1000);
                return (
                  <td>
                    <GoogleAgendaLink
                      text={props.dataItem.Descricao}
                      startDate={date1}
                      endDate={date2}
                      email={email}
                    />
                  </td>
                );
              }}
            />
          </GridInline>
        </FormRow>
        <PopUpConfirm
          onConfirm={confirmDelete}
          visible={popUpConfirmDelete}
          setVisible={setPopUpConfirmDelete}
          title="Confirmação"
          message="Você tem certeza que deseja excluir a agenda selecionada?"
        />
      </>
    </div>
  );
};

export default Schedule;
